import log from 'salvo-lite/log'
// import axios from 'axios'
import Helpers from '../helpers/Helpers'

export default class ProductPdf {
    constructor (theme, elem) {
        this._elem = elem
        this._endpoint = 'https://pdf.twentytwentyone.eastsideco.io/api/pdf'
        this._loading = false
        this._count = 0
        this._options = {
            ...{
                url: null,
                title: ''
            },
            ...JSON.parse(this._elem.dataset[Helpers.camelize(this.constructor.name)] || '{}')
        }
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        log.debug(this.constructor.name, 'Initiating', this)
        // NOTE:
        // This component no longer does anything as the api has changed slightly so that the popups work correctly - leaving this in place for now so we can refrence back if need be further down the line

        // this._elem.addEventListener('click', e => {
        //     e.preventDefault()
        //     if (this._loading) return false
        //     let originalContent = this._elem.textContent
        //     this._elem.textContent = 'Loading, please wait...'
        //     this._loading = true
        //     axios.request({
        //         url: this._endpoint,
        //         method: 'post',
        //         responseType: 'blob',
        //         data: {
        //             url: this._options.url
        //         },
        //         headers: {
        //             'Authorization': 'Bearer mP34wqLBbdPNxDOraTiE35XxsYT3hIzfXfqDkOmQn0p3sGtbfwNUn4YepQUb'
        //         }
        //     }).then(response => {
        //         console.log(response, '---product pdf response')
        //         let file = new Blob([response.data], {
        //             type: 'application/pdf'
        //         })
        //         let blobURL = URL.createObjectURL(file)
        //         window.open(blobURL)
        //         this._elem.textContent = originalContent
        //     })
        //     .catch(error => {
        //         console.log(error, '---product pdf error')
        //     })
        //     .finally(() => {
        //         this._loading = false
        //     })
        // })
        log.debug(this.constructor.name, 'Initiated', this)
    }
}



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ProductPDF.js